exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-1f9ddb76!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Manuais.vue
// module id = 37
// module chunks = 0